module.exports = __webpack_public_path__ + "static/medikts-06eddd106cda2e8c57e47b3fd33680e3.png";